import { api } from '../../../../redux/setupAxios';
import { dateToTimestamp } from '../../../helper';

export const STATISTIC_URL = 'statistic';

export async function fetchStatistics({ from, to, merchantId }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now(), true);
	try {
		const { data } = await api.get(`${STATISTIC_URL}/multi-overview/${from}/${to}/${merchantId}`);
		return data;
	} catch (e) {
		return [];
	}
}